import React, { useEffect } from 'react';
import {useLocation, useParams, useSearchParams} from 'react-router-dom';
import { useAppDispatch } from 'src/store/hooks';
import { fetchReports } from 'src/actions/community/reportsActions';
import { queryParams } from "src/helpers/UrlHelpers";

import PageHeader from "src/componets/PageHeader";
import PageLayout from 'src/pages/community/_partials/PageLayout';
import List from "./_partials/_List";

const LIMIT = 50;

const Reports: React.FC = () => {
  const dispatch = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const { pathname } = useLocation();
  const { app_id } = useParams();

  useEffect(() => {
    const params: any = {
      app_id: app_id,
      limit: LIMIT,
      offset: (currentPage - 1) * LIMIT
    };

    dispatch(fetchReports(params));
  }, [app_id, currentPage, pathname, dispatch]);

  return (
    <PageLayout>
      <PageHeader title={'Reports'} />

      <div className='v-container-fluid'>
        <List limit={LIMIT} />
      </div>
    </PageLayout>
  );
}

export default Reports;
